// Core
import React, { useState, useEffect } from "react"
import { isMobile } from "react-device-detect"

// Utils
import { localiseString } from "../../utils/localiseString"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import JsonText from "../_jsonText"

// Style
import styles from "./intro.module.scss"

const Intro = ({
  count,
  scrollEvent,
  contentful_id,
  menuTitle,
  introParagraph,
  contributors,
  secondaryText,
}) => {
  const [loaded, setLoaded] = useState(false)

  const anchorOverride = menuTitle
    ? menuTitle.replace(/\s+/g, "-").toLowerCase()
    : null

  const checkScroll = (value, way, obj) => {
    if (value === "intro-" + contentful_id) scrollEvent(way, count, obj)
  }

  useEffect(() => {
    setLoaded(true)

    setTimeout(() => {
      if (!isMobile && scrollEvent) window.scroll.on("call", checkScroll)
    }, 200)
  }, [])

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "performance"}`}
        className={`${styles.wrap} ${!isMobile ? styles.isDesktop : ""} ${
          loaded ? styles.loaded : ""
        } container`}
        data-scroll
        data-scroll-call={`intro-${contentful_id}`}
        data-scroll-offset="30%, 30%"
      >
        <div className={`cols flex flex--center`}>
          <div className={`col m12 tp11 t10 d8`}>
            <div className={styles.content}>
              <p className="mono">{localiseString("About the episode")}</p>
              <JsonText {...introParagraph} />

              {contributors && (
                <ul className={styles.contributors}>
                  {contributors.map((contributor, x) => (
                    <li key={`role-${x}`} className={styles.contributorsItem}>
                      {contributor.names &&
                        contributor.names.map((contributorName, y) => (
                          <h4
                            key={`contributor-${y}`}
                            className={styles.contributorName}
                          >
                            {contributorName}
                          </h4>
                        ))}

                      {contributor.role && (
                        <p className={`mono ${styles.contributorRole}`}>
                          {contributor.role}
                        </p>
                      )}
                    </li>
                  ))}
                </ul>
              )}

              {secondaryText && (
                <span className={`${styles.secondary} mono`}>
                  {secondaryText}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </ScrollSection>
  )
}

export default Intro
